/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Supported social post platforms for verifySocialPost (backend/src/services/socialPostVerification).
 * @export
 */
export const SocialPostPlatform = {
    tiktok: 'tiktok',
    instagram: 'instagram',
    facebook: 'facebook',
    twitter: 'twitter',
    youtube: 'youtube',
    reddit: 'reddit'
} as const;
export type SocialPostPlatform = typeof SocialPostPlatform[keyof typeof SocialPostPlatform];


export function instanceOfSocialPostPlatform(value: any): boolean {
    for (const key in SocialPostPlatform) {
        if (Object.prototype.hasOwnProperty.call(SocialPostPlatform, key)) {
            if (SocialPostPlatform[key as keyof typeof SocialPostPlatform] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SocialPostPlatformFromJSON(json: any): SocialPostPlatform {
    return SocialPostPlatformFromJSONTyped(json, false);
}

export function SocialPostPlatformFromJSONTyped(json: any, ignoreDiscriminator: boolean): SocialPostPlatform {
    return json as SocialPostPlatform;
}

export function SocialPostPlatformToJSON(value?: SocialPostPlatform | null): any {
    return value as any;
}

export function SocialPostPlatformToJSONTyped(value: any, ignoreDiscriminator: boolean): SocialPostPlatform {
    return value as SocialPostPlatform;
}

